const Recommendation = () => {
    return (
        <div className='min-h-[80vh]'>
        <h1 className='text-4xl pt-8 text-white text-center hover:text-indigo-500  font-semibold'>My Recomendation</h1>
        <div className='grid lg:grid-cols-3 grid-cols-1 container mx-auto py-14 gap-10'>
  
        <div className='animate__animated animate__fadeInLeft animate__delay-.5s'>
            <img src="/recomendation/recomendation1.jpg" alt="" />
          </div>

           <div className='animate__animated animate__bounceInDown animate__delay-1s'>
            <img src="/recomendation/phero.png" alt="" />
          </div>

           <div className='animate__animated animate__fadeInUp animate__delay-1s'>
            <img src="/recomendation/pherolevel2.png" alt="" />
          </div>

           <div className='animate__animated animate__fadeInRight animate__delay-2s'>
            <img src="/recomendation/phitron.png" alt="" />
          </div>
   
  
  
        {/* <div className='animate__animated animate__fadeInUp animate__delay-1s'>
            <img src="/achivement/blackbelt.png" alt="" />
          </div>
  
         
  
        <div className='animate__animated animate__fadeInRight animate__delay-1s'>
            <img src="/achivement/achievement.jpg" alt="" />
          </div>
  
          <div className='animate__animated animate__fadeInLeft animate__delay-.5s'>
            <img src="/achivement/webdevelopment.jpeg" alt="" />
          </div>
          <div className='animate__animated animate__fadeInDown animate__delay-1s'>
            <img src="/achivement/python.jpeg" alt="" />
          </div>
  
          <div className='animate__animated animate__fadeInRight animate__delay-.5s'>
            <img src="/achivement/java.jpeg" alt="" />
          </div>
          <div className='animate__animated animate__fadeInRight animate__delay-1s'>
            <img src="/achivement/contest.jpeg" alt="" />
          </div>
  
          <div className='animate__animated animate__fadeInUp animate__delay-1s'>
            <img src="/achivement/iusachieve.png" alt="" />
          </div>
    
  
          <div className='animate__animated animate__fadeInRight animate__delay-2s'>
            <img src="/achivement/plevel2.png" alt="" />
          </div>
          <div className='animate__animated animate__fadeInUp animate__delay-.5s'>
            <img src="/achivement/pytron.jpg" alt="" />
          </div>
  
        
          <div className='animate__animated animate__fadeInDown animate__delay-1s'>
            <img src="/achivement/hackerrank.png" alt="" />
          </div>
  
          <div className='animate__animated animate__fadeInLeft animate__delay-.5s'>
            <img src="/achivement/jobplacement.jpeg" alt="" />
          </div> */}
          
          
          
          
          
        </div>
      </div>
    );
};

export default Recommendation;